import { render, staticRenderFns } from "./courseItem.vue?vue&type=template&id=a4450a4a&scoped=true&"
import script from "./courseItem.vue?vue&type=script&lang=js&"
export * from "./courseItem.vue?vue&type=script&lang=js&"
import style0 from "./courseItem.vue?vue&type=style&index=0&id=a4450a4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4450a4a",
  null
  
)

export default component.exports